import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21976fd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommendations" }
const _hoisted_2 = { class: "recommendations__content" }
const _hoisted_3 = { class: "recommendations__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__title" }, "Рекомендации", -1))
const _hoisted_5 = { class: "recommendations__subtitle" }
const _hoisted_6 = { class: "recommendations__list" }
const _hoisted_7 = { class: "recommendations__list-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__subtitle" }, "Консультация стоматолога:", -1))
const _hoisted_9 = { class: "recommendations__list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__subtitle" }, " Мероприятия для оценки десен и обучения: ", -1))
const _hoisted_11 = { class: "recommendations__list" }

import { computed, PropType } from 'vue'
import { ConsultationType } from '@/shared/types'
import { CONSULTATIONS_MAP, MEASURES_MAP } from '@/shared/constants'
import { declination } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  consultation: Object as PropType<ConsultationType>,
  isPlaqueReport: Boolean,
  isPeriodontalReport: Boolean,
},
  setup(__props) {

const props = __props



const consultations = computed(() => {
  return props.consultation.consultations.filter((consultation) =>
    CONSULTATIONS_MAP.has(consultation)
  )
})
const measures = computed(() => {
  return props.consultation.consultations.filter((consultation) =>
    MEASURES_MAP.has(consultation)
  )
})

const signature = computed(() =>
  declination(props.consultation.reCleaning, ['месяц', 'месяца', 'месяцев'])
)

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _renderSlot(_ctx.$slots, "edit")
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.isPeriodontalReport
            ? 'Следующий приём'
            : 'Следующая профессиональная гигиена зубов') + ": ", 1),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, " Через " + _toDisplayString(__props.consultation.reCleaning) + " " + _toDisplayString(_unref(signature)), 1)
      ]),
      (__props.isPlaqueReport)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_divider, { class: "recommendations__divider" }),
            _hoisted_8,
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(consultations), (consultationItem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "recommendations__list-item"
                }, _toDisplayString(_unref(CONSULTATIONS_MAP).get(consultationItem)), 1))
              }), 128))
            ]),
            _createVNode(_component_el_divider, { class: "recommendations__divider" }),
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(measures), (consultationItem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "recommendations__list-item"
                }, _toDisplayString(_unref(MEASURES_MAP).get(consultationItem)), 1))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})